import React from "react";
import { DocumentCard,
    DocumentCardDetails,
    DocumentCardTitle,
    DocumentCardActivity} from '@fluentui/react';
import {ApproverDialog} from "./ApproverDialog";

class ApproveSIteTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showApproveDialog: false
        }
    }

    adjustDate()
    {
        return new Date(this.props.site.expirationDate + 'Z').toLocaleDateString();
    }

    _mapOwnerForPeople(user) {
        return [{
            name: user.displayName
        }];
    }

    render() {
        
        return (
            <div>
                <DocumentCard styles={cardStyles} >
                    <DocumentCardDetails styles={detailsStyles} >
                        <div style={titleStyles}>
                            <DocumentCardTitle title={"Create site"} shouldTruncate={false} />
                        </div>
                        <div style={statusStyles}>{'Site name: ' + this.props.site.name}</div>
                        <div style={statusStyles}>{'Status: ' + this.props.site.siteStatus}</div>
                        <div style={statusStyles}>{'Cost: ' + this.props.site.farmLocation.cost}</div>
                        <div style={statusStyles}>{'Site quota: ' + this.props.site.quotaValue.quotaSize + ' GB'}</div>
                        <div style={statusStyles}>{'Expiration end date: ' + this.adjustDate()}</div>
                        <div style={createdByStyles}>Created by: </div>

                    </DocumentCardDetails>
                    <DocumentCardActivity
                        activity={`Created on ${new Date(this.props.site.created).toLocaleString()}`}
                        people={this._mapOwnerForPeople(this.props.site.author)}
                    />
                        <ApproverDialog btnStyle={btnEditStyles} buttonName="Decision"
                                        reason = {this.props.site.purpose}
                                        title="Approve or reject site creation"
                                        onReject = {this.props.onReject}
                                        onApprove = {this.props.onApprove}
                        />
                </DocumentCard>
            </div>
        );
    }
}
// const urlStyles = {
//     root: {
//         color: 'rgb(0, 120, 212)',
//         fontSize: '14px',
//         fontWeight: 'bold'
//     }
// }
const statusStyles = {
    paddingLeft: '12px',
    fontSize: '12px'
}

const createdByStyles = {
    paddingLeft: '16px',
    fontSize: '12px'
}

const btnEditStyles = {
    root: {
        width: '100%'
    }
}

const titleStyles = {
    maxHeight: '35px'
}

const cardStyles = {
    root: {
        marginRight: 20,
        marginBottom: 20,
        width: 400,
        height:300
    }
};

const detailsStyles = {
    root: {
        height: 220
    }
}

export default ApproveSIteTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ApproveSIteTask.js